import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NumaLanding from "@/pages/NumaLanding";
import Science from "@/pages/Science";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NumaLanding />} />
          <Route path="/science" element={<Science />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
